import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'ark-lib-block-modal',
  templateUrl: './block-modal.component.html',
  styleUrls: ['./block-modal.component.css'],
})
export class BlockModalComponent  implements OnInit {
  @Input() userNickname!: string;
  constructor(
    private modalController: ModalController,
  ) { }

  ngOnInit() {}

  confirm() {
    this.modalController.dismiss({ confirmed: true });
  }

  cancel() {
    this.modalController.dismiss({ confirmed: false });
  }
}
